exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mdcG2{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-right:8px}._3rBvr{color:inherit;text-decoration:none}._3rBvr :hover{color:#000;opacity:.7}._3FCtd{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;top:100%;width:290px;padding:10px;background:#fff;-webkit-box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75);box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75)}._3F8sF{vertical-align:text-bottom}._3FCtd .Select{width:100%}._3FCtd .Select-control{border:1px solid #ccc;border-radius:2px;height:30px;font-size:13px;line-height:1em}._3FCtd .Select--single>.Select-control .Select-value{line-height:30px}", ""]);

// exports
exports.locals = {
	"root": "mdcG2",
	"content": "_3rBvr",
	"popup": "_3FCtd",
	"icon": "_3F8sF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/SearchPanel/SaveSearch/SaveSearch.css
// module id = 1891
// module chunks = 0 1 15 17 22